/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Output, Input, Component, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CreateUserRequest, User } from 'app/page-modules/tenant-management/models';

@Component({
  selector: 'og-user-details-form',
  templateUrl: './user-details-form.component.html',
  styleUrls: ['./user-details-form.component.scss'],
  standalone: false
})
export class UserDetailsFormComponent implements OnChanges {
  /** The user details to pre-fill the form with */
  @Input() userDetails: User | undefined;
  /** Defines if the is in loading state */
  @Input() loading: boolean;
  /** Defines if the form cancel button should be present */
  @Input() enableFormCancel = true;
  /** Defines if the approval ID should be required */
  @Input() isApprovalIdRequired = false;
  /** Emits user update changes */
  @Output() userUpdateChange = new EventEmitter<User>();
  /** Emits user save changes */
  @Output() userSaveChange = new EventEmitter<CreateUserRequest>();
  /** Emits form cancel changes */
  @Output() formCancelChange = new EventEmitter<void>();

  userDetailsFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.userDetailsFormGroup = this.formBuilder.group({
      firstName: [!this.userDetails ? '' : this.userDetails.firstName, Validators.required],
      lastName: [!this.userDetails ? '' : this.userDetails.lastName, Validators.required],
      email: [!this.userDetails ? '' : this.userDetails.email, Validators.required],
      picture: [!this.userDetails ? '' : this.userDetails.picture],
      issueKey: ['', this.isApprovalIdRequired ? Validators.required : Validators.nullValidator]
    });
  }

  ngOnChanges(): void {
    this.userDetailsFormGroup = this.formBuilder.group({
      firstName: [!this.userDetails ? '' : this.userDetails.firstName, Validators.required],
      lastName: [!this.userDetails ? '' : this.userDetails.lastName, Validators.required],
      email: [!this.userDetails ? '' : this.userDetails.email, Validators.required],
      picture: [!this.userDetails ? '' : this.userDetails.picture],
      issueKey: ['', this.isApprovalIdRequired ? Validators.required : Validators.nullValidator]
    });
  }

  updateUser(): void {
    this.userUpdateChange.next({
      email: this.userDetailsFormGroup.get('email')!.value,
      firstName: this.userDetailsFormGroup.get('firstName')!.value,
      lastName: this.userDetailsFormGroup.get('lastName')!.value,
      picture: this.userDetailsFormGroup.get('picture')!.value
    });
  }

  saveUser(): void {
    if (this.userDetailsFormGroup.valid) {
      this.userSaveChange.next({
        // validity check ensures these are defined
        email: this.userDetailsFormGroup.get('email')!.value,
        firstName: this.userDetailsFormGroup.get('firstName')!.value,
        lastName: this.userDetailsFormGroup.get('lastName')!.value,
        auditDetails: { approvalId: this.userDetailsFormGroup.get('issueKey')!.value }
      });
    }
  }

  cancelForm(): void {
    this.formCancelChange.next();
  }
}
